import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { reduxForm, Field, SubmissionError } from 'redux-form';
import {
	createValidator,
	required,
	email,
} from '@sparefoot/react-core/utils/validation';

import { Button } from 'components/core/Button';
import { Alert } from 'components/core/Alert';
import { LoadingMask } from 'components/core/LoadingMask';
import {
	Form,
	FormGroup,
	FormItem,
	ReduxFormInput,
	ReduxTextarea,
	ReduxCAPTCHA,
} from 'components/core/Form';

const validate = createValidator({
	name: [required],
	email: [required, email],
	comments: [required],
});

const withSubmitHandler = (Component) => {
	const WithSubmitHandler = (props) => {
		const onSubmit = (data) =>
			props.onSubmit(data).then(({ error, payload }) => {
				if (error) {
					throw new SubmissionError({ _error: error });
				}
				return props.onSuccess({ payload });
			});

		return (
			<Component
				{...props}
				onSubmit={onSubmit}
			/>
		);
	};
	WithSubmitHandler.propTypes = {
		onSubmit: PropTypes.func.isRequired,
		onSuccess: PropTypes.func.isRequired,
	};
	return WithSubmitHandler;
};

export const enhance = compose(
	withSubmitHandler,
	reduxForm({
		form: 'contact-form',
		validate,
	}),
);

export function ContactForm({
	handleSubmit,
	submitting,
	error,
	invalid,
	recaptchaSiteKey,
}) {
	return (
		<Form
			className="contact-form"
			onSubmit={handleSubmit}
			invalid={invalid}
			successLabel="success-contact-form"
			failureLabel="fail-contact-form"
		>
			{!!error && <Alert type="warning">{error}</Alert>}
			<div className="form-fields">
				<FormGroup>
					<FormItem>
						<Field
							name="name"
							id="name"
							label="Name"
							component={ReduxFormInput}
						/>
					</FormItem>
				</FormGroup>
				<FormGroup>
					<FormItem>
						<Field
							name="companyName"
							id="companyName"
							label="Company Name"
							component={ReduxFormInput}
						/>
					</FormItem>
				</FormGroup>
				<FormGroup>
					<FormItem>
						<Field
							name="email"
							id="email"
							label="Email Address"
							component={ReduxFormInput}
						/>
					</FormItem>
				</FormGroup>
				<FormGroup>
					<FormItem>
						<Field
							name="phone"
							id="phone"
							label="Phone Number"
							component={ReduxFormInput}
						/>
					</FormItem>
				</FormGroup>
				<FormGroup>
					<FormItem>
						<Field
							name="comments"
							id="comments"
							label="Comments"
							component={ReduxTextarea}
						/>
					</FormItem>
				</FormGroup>
				<FormGroup>
					<FormItem>
						<Field
							name="recaptchaToken"
							sitekey={recaptchaSiteKey}
							component={ReduxCAPTCHA}
						/>
					</FormItem>
				</FormGroup>
				<FormGroup>
					<FormItem>
						<Button
							primary
							type="submit"
							disabled={submitting}
						>
							Submit Request
						</Button>
					</FormItem>
				</FormGroup>
				{submitting && <LoadingMask />}
			</div>
		</Form>
	);
}

ContactForm.propTypes = {
	handleSubmit: PropTypes.func.isRequired,
	recaptchaSiteKey: PropTypes.string.isRequired,
	submitting: PropTypes.bool,
	error: PropTypes.string,
	invalid: PropTypes.bool,
};

export default enhance(ContactForm);
